import { resource } from "./resource";

const api = resource("/policy");

export const createPolicy = async (input = {}) => await api.post("", input);

export const getSelfPolicy = async () => await api.get("/self");

export const updatePolicy = async (policyId, input = {}) => await api.put(`/${policyId}`, input);
